import React from "react";
import Progress3Svg from "../../../assets/svgicons/progress-bar/progress_bar_3.svg";

const Progress3 = (props) => {
  return <img src={Progress3Svg} alt="Progress 3" {...props} />;
};

export default Progress3;
